
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    watch(
      () => route.path,
      async () => {
       MenuComponent.reinitialization();
      }
    );

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const checkRole = (roles: Array<string>) => {
      let found = false;
      //console.log("roles: ", roles);
      //console.log("user roles: ", currentUser.value.userRoles);
      if (roles && currentUser.value.userRoles) {
        for (let index = 0; index < roles.length; index++) {
          const role = roles[index];
          if (currentUser.value?.userRoles?.indexOf(role) !== -1) {
            found = true;
            break;
          }
        }
      } else {
        found = false;
      }
      return found;
    };

    const openPage = function(hrf) 
    {
      if(hrf != null && hrf != "" && hrf != router.currentRoute.value.name) {
        router.push({ name: hrf });
      }
    }

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      checkRole,
      openPage,
    };
  },
});
